/**
 * components util
 */

/**
 * 清理空值，对象
 * @param children
 * @returns {*[]}
 */
export function filterEmpty(children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ""));
}

/**
 * 获取字符串长度，英文字符 长度1，中文字符长度2
 * @param {*} str
 */
export const getStrFullLength = (str = "") =>
  str.split("").reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0);
    if (charCode >= 0 && charCode <= 128) {
      return pre + 1;
    }
    return pre + 2;
  }, 0);

/**
 * 截取字符串，根据 maxLength 截取后返回
 * @param {*} str
 * @param {*} maxLength
 */
export const cutStrByFullLength = (str = "", maxLength) => {
  let showLength = 0;
  return str.split("").reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0);
    if (charCode >= 0 && charCode <= 128) {
      showLength += 1;
    } else {
      showLength += 2;
    }
    if (showLength <= maxLength) {
      return pre + cur;
    }
    return pre;
  }, "");
};

/**
 * 功能描述： <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 14:34 2021/2/26
 **/
const _upSort = () => {
  return function(a, b) {
    return a.sort - b.sort;
  };
};

/**
 * 功能描述：升序排序 <br>
 * 〈〉
 * @Param 必须存在sort\jtypes属性
 * @Return
 * @Author CHU
 * @Date 14:23 2021/2/26
 **/
export const upSort = data => {
  // console.log(" === upSort === ");

  data.sort(_upSort());

  data.map(item => {
    if (item.jtypes | upSort(item.jtypes));
  });
  return data;
};

/**
 * 功能描述：HTML转字符串 <br>
 * 〈〉
 * @Param HTML格式的字符串
 * @Return 去掉HTML标签后的文本字符串
 * @Author CHU
 * @Date 9:02 2021/1/29
 **/
export const toText = h => {
  let input = h;
  return input
    .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
    .replace(/<[^>]+?>/g, "")
    .replace(/\s+/g, " ")
    .replace(/ /g, " ")
    .replace(/>/g, " ");
};

/***
 * 功能描述：获取文件后缀类型 <br>
 * 〈〉
 * @Param 需要获取的文件字符串
 * @Return 文件后缀字符串
 * @Author CHU
 * @Date 15:46 2021/2/19
 **/
const fileType = filename => {
  if (!filename || typeof filename != "string") {
    return false;
  }
  let a = filename
    .split("")
    .reverse()
    .join("");
  let b = a
    .substring(0, a.search(/\./))
    .split("")
    .reverse()
    .join("");

  // console.log("==== file Type:", b);
  return b;
};

/**
 * 功能描述：通过文件类型返回对应的图片 <br>
 * 〈〉
 * @Param 文件类型
 * @Return 对应图片路径
 * @Author CHU
 * @Date 15:39 2021/2/19
 **/
export const getImgPath = t => {
  let img = require("@/assets/imgs/resource/btn_word.png");
  t = fileType(t);
  switch (t) {
    case "doc":
    case "docx":
      img = require("@/assets/imgs/resource/btn_word.png");
      break;
    case "xls":
    case "xlsx":
      img = require("@/assets/imgs/resource/btn_xls.png");
      break;
    case "ppt":
    case "pptx":
      img = require("@/assets/imgs/resource/btn_ppt.png");
      break;
    case "pdf":
      img = require("@/assets/imgs/resource/btn_pdf.png");
      break;
  }

  return img;
};
